<template>
  <div style="padding: 32px 0">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-5">
          <div class="card shadow-sm">
            <div class="card-body text-center py-5">
              <i class="fab fa-whatsapp fa-2x text-primary"></i>
              <h4 class="mt-2 mb-0">Conectar WhatsApp</h4>
              <p class="mb-4">Conecte sua conta empresarial para usar o LeBot</p>
              <div>
                <router-link to="/config" class="btn">Mais tarde</router-link>
                <button class="btn btn-primary" @click="signup">Conectar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
export default {
  name: "Connect",
  components: {TopBar},
  data() {
    return {
    }
  },
  methods: {
    signup() {
      // Conversion tracking code
      window.fbq && window.fbq('trackCustom', 'WhatsAppOnboardingStart', {appId: '735950484203465', feature: 'whatsapp_embedded_signup'});

      // Launch Facebook login
      FB.login((response) => {
        if (response.authResponse) {
          const code = response.authResponse.code;
          console.log(code);
          this.authFacebook(code);
          // The returned code must be transmitted to your backend,
          // which will perform a server-to-server call from there to our servers for an access token
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      }, {
        config_id: '484899881027574',
        response_type: 'code',
        override_default_response_type: true
      });
    },

    authFacebook(code) {
      this.$http.post('business/connect', { code })
        .then(res => {
          this.load = false;

          if (!res.data || !res.data.success) {
            this.$swal('Não foi possível conectar');
            return;
          }

          window.location.href = '/';

        }, res => {
          this.load = false;
          this.$swal('Não foi possível transferir este atendimento!');
        });
    }
  },

  created() {
    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      FB.init({
        appId: '735950484203465',
        cookie: true,
        xfbml: true,
        version: 'v20.0'
      });
    };

    (function(d, s, id){
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
}
</script>

<style scoped>

</style>
